import React from 'react'
import { Col, Row } from 'antd'
import { numberWithComma } from 'helpers/format'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { VAT_TYPE, VAT_TYPE_TEXT } from 'helpers/constanst'
import { Data, Product } from 'Store/orders/types'

type Props = {
  detail?: Data
  vat?: number
  refundAmount?: number
}

const CustomerSummayTax: React.FunctionComponent<Props> = props => {
  const { detail, vat = 0, refundAmount = 0 } = props
  let percentVat = 0
  if (vat === 7) {
    percentVat = vat
  }

  const products = detail?.products[0]?.products || []

  const getTotalBeforeDiscount = () => {
    let total = 0
    products.forEach((item: Product) => {
      total += item.price_before_discount
    })
    return total
  }

  const getTotalDiscount = () => {
    let total = 0
    products.forEach((item: Product) => {
      total += item.total_discount
    })
    return total
  }

  const getTotalProductPrice = () => {
    let total = 0
    products.forEach((item: Product) => {
      total += item.total_price
    })
    return total
  }

  const renderInfoItem = (title: any, value: any) => {
    return (
      <Row justify="space-between">
        <Col>
          <InfoTitle>{title}</InfoTitle>
        </Col>
        <Col offset={1}>
          <InfoValue>{value || '-'}</InfoValue>
        </Col>
      </Row>
    )
  }

  const totalBeforeDiscount = getTotalBeforeDiscount()
  const totalDiscount = getTotalDiscount()
  const tailDiscount = detail?.payment_detail?.tail_discount_amount || 0
  const totalProductPrice = getTotalProductPrice() - tailDiscount - refundAmount
  const hasProductDiscount = totalDiscount > 0
  const isExcludeVat = detail?.payment_detail?.vat_type === VAT_TYPE.EX
  const vatType = detail?.payment_detail?.vat_type

  const calculateVat = () => {
    if (isExcludeVat) {
      const vat = (percentVat * totalProductPrice) / 100
      const total_amount = totalProductPrice + vat
      return { vat, total_amount }
    } else {
      const priceExcludeVat = (totalProductPrice * 100) / (100 + percentVat)
      const vat = priceExcludeVat * (percentVat / 100)
      return { vat, total_amount: totalProductPrice }
    }
  }

  const netPrice = calculateVat().total_amount
  return (
    <Row justify="end">
      <Col md={24} xs={24}>
        {hasProductDiscount &&
          renderInfoItem('รวมราคาสินค้าก่อนหักส่วนลด', `${numberWithComma(totalBeforeDiscount, true)} บาท`)}
        {hasProductDiscount &&
          renderInfoItem('หัก ส่วนลดสินค้า', `${numberWithComma(totalDiscount, true)} บาท`)}
        {renderInfoItem('รวมราคาสินค้า', `${numberWithComma(getTotalProductPrice(), true)} บาท`)}
        {tailDiscount > 0 &&
          renderInfoItem(`หัก ส่วนลดท้ายบิล`, `${numberWithComma(tailDiscount, true)} บาท`)}
        {refundAmount > 0 &&
          renderInfoItem(`หัก คืนเงิน/คืนสินค้า`, `${numberWithComma(refundAmount, true)} บาท`)}
        {tailDiscount > 0 &&
          renderInfoItem('ราคารวมทั้งสิ้น ', `${numberWithComma(totalProductPrice, true)} บาท`)}
        {renderInfoItem(
          `ภาษีมูลค่าเพิ่ม ${percentVat}% (${vatType === VAT_TYPE.EX ? VAT_TYPE_TEXT.EX : VAT_TYPE_TEXT.IN})`,
          `${numberWithComma(calculateVat().vat, true)} บาท`,
        )}
        {renderInfoItem('จำนวนเงินรวมทั้งสิ้น', `${numberWithComma(netPrice, true)} บาท`)}
      </Col>
    </Row>
  )
}

const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  //color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const InfoValue = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  margin-right: 10px;
`

export default CustomerSummayTax
